module.exports = __webpack_public_path__ + "static/media/paragraphe2.d5314735.jpg";